import React from "react";
import "./InputField.css";

const InputField = ({ label, type, placeholder, options = [], value, onChange, error, name, icon }) => {
  return (
    <div className="input-group">
      <label className="input-label">{label}</label>

      <div className="input-wrapper">
        {icon && <span className="input-icon">{icon}</span>}

        {type === "select" ? (
          <select
            name={name}
            value={value}
            onChange={onChange}
            className={`input-field ${icon ? "with-icon" : ""}`}
          >
            <option value="">{placeholder}</option>
            {options.map((opt, i) => (
              <option key={i} value={opt}>{opt}</option>
            ))}
          </select>
        ) : (
          <input
            type={type}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`input-field ${icon ? "with-icon" : ""}`}
          />
        )}
      </div>

      {error && <span className="input-error">{error}</span>}
    </div>
  );
};

export default InputField;
